export const TEBEX_PUBLIC_TOKEN = process.env.REACT_APP_TEBEX_PUBLIC_TOKEN || '';
export const TEBEX_HEADLESS_API = process.env.REACT_APP_TEBEX_HEADLESS_API || 'https://headless.tebex.io/api';
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || (typeof window !== 'undefined' ? window.location.origin : 'https://petlings.gg');
